const directionToSymbol = (degrees) => {
  const symbols = [
    "N",
    "NNE",
    "NE",
    "ENE",
    "E",
    "ESE",
    "SE",
    "SSE",
    "S",
    "SSW",
    "SW",
    "WSW",
    "W",
    "WNW",
    "NW",
    "NNW",
  ];
  const index =
    Math.round(degrees / (360 / symbols.length)) % (symbols.length - 1);
  return symbols[index];
};

export const temperatureFormat = (t, metric = true, places = 1) => {
  if (typeof t === "number") {
    return `${(metric ? t : t * 1.8 + 32).toFixed(places)}°${
      metric ? "C" : "F"
    }`;
  }
};

export const pressureFormat = (p) => {
  if (typeof p === "number") {
    return `${p} hPa`;
  }
};

export const windFormat = (s, d, metric = true) => {
  if (typeof s === "number") {
    const speed = (s * (metric ? 3.6 : 2.237)).toFixed(1);
    let output = `${speed} ${metric ? "km/h" : "mph"}`;

    if (typeof d === "number") {
      output += " " + directionToSymbol(d);
    }

    return output;
  }
};

export const humidityFormat = (h) => {
  if (typeof h === "number") {
    return `${h}%`;
  }
};

export const cloudinessFormat = (c) => {
  if (typeof c === "number") {
    return `${c}%`;
  }
};

export const rainFormat = (r) => {
  if (typeof r === "number") {
    return `${r}mm`;
  }
};

export const channelDaysRemaining = (balance) => Math.round(balance / 370 / 24);
